import { SpaceBetween } from "@cloudscape-design/components-themed";

import { Main } from "../components/switch-payment-provider/Main";
import { PERMISSIONS } from "../configs/constants";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

const SwitchPaymentProvider = () => {
  // 権限制御
  useAuthenticationHook(PERMISSIONS.EXAMINE);

  return (
    <SpaceBetween size="l">
      <Main />
    </SpaceBetween>
  );
};

export default SwitchPaymentProvider;
